import { render } from "./category-levels-assessment-mobile.vue?vue&type=template&id=d4472b0a&scoped=true&ts=true"
import script from "./category-levels-assessment-mobile.vue?vue&type=script&lang=ts"
export * from "./category-levels-assessment-mobile.vue?vue&type=script&lang=ts"

import "./category-levels-assessment-mobile.vue?vue&type=style&index=0&id=d4472b0a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4472b0a"]])

export default __exports__